import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import InputPhone from "./InputPhone";
import Icon, { ICON_NAMES } from 'components/Icon';


const Input = props => {
  const { field, form, type, placeholder, readOnly, disabled, className, icon, phoneMask, isRequired, annotation, validationError, validationTouch, setMask, labelClassName } = props;

  const error = validationError || form.errors[field.name];

  const hasValue = field.value !== null && field.value !== undefined && field.value !== '';
  const [isFocused, setFocus] = useState(false);
  const [passType, setType] = useState("password");

  const handleTypeToggle = () => {
    if (passType === "password") {
      setType("text");
    } else {
      setType("password");
    }
  }

  const handleChange = (event) => {
    const { field, form, normalize } = props;
    if (normalize) {
      const value = normalize(event.target.value);
      form.setFieldValue(field.name, value);
    } else {
      form.setFieldValue(field.name, event.target.value);
    }
  };

  let inpType = "text";
  if (type === "password") {
    inpType = passType;
  } else {
    inpType = type;
  }

  if (phoneMask && setMask && field.value === "") {
    form.setFieldValue(field.name, "+1");
  }
  if (phoneMask && !setMask && field.value === "+1") {
    form.setFieldValue(field.name, "");
  }

  return (
    <label className={classNames(`field field-input ${className}`, {
      'field--focused': isFocused,
      'field--filled': hasValue,
      'field--error': (error != null) && (form.submitCount > 0 || form.touched[field.name] || validationTouch),
      'field--inactive': readOnly,
      'field--disabled': disabled,
    })}>
      <div className="field__data">
        {
          <span className={`field-label field-input__label ${labelClassName}`}>
            {placeholder}
            {
              isRequired && <span className="field-label__required">*</span>
            }
          </span>
        }
        {
          phoneMask
            ? <InputPhone
              name={field.name}
              type="phone"
              placeholder={placeholder}
              className="field__input field__input--phone"
              readOnly={readOnly}
              disabled={disabled}
              onFocus={() => !readOnly && setFocus(true)}
              onBlur={event => {
                field.onBlur(event);
                setFocus(false);
              }}
              value={field.value}
              onChange={handleChange}
            />
            : <input
              name={field.name}
              type={inpType}
              className="field__input"
              placeholder={placeholder}
              readOnly={readOnly}
              disabled={disabled}
              onFocus={() => !readOnly && setFocus(true)}
              onBlur={event => {
                field.onBlur(event);
                setFocus(false);
              }}
              value={field.value || ""}
              onChange={handleChange}
            />
        }
        {
          annotation &&
          <span className='field-annotation'>{annotation}</span>
        }
      </div>
      {
        icon != null && (
          type === "password"
            ? <div className="field__icon-container" onClick={handleTypeToggle}>
              <Icon
                name={ICON_NAMES[icon]}
                className="field__icon"
                active={inpType === "password"} />
            </div>
            : <div className="field__icon-container">
              <Icon name={ICON_NAMES[icon]} className="field__icon" />
            </div>
        )
      }
      {
        (form.submitCount > 0 || form.touched[field.name] || validationTouch) &&
        <span className='field-error'>{error}</span>
      }
    </label>
  )
}

Input.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
}

Input.defaultProps = {
  type: 'text',
  className: '',
  labelClassName: '',
  form: {
    errors: {}
  },
  field: {
    name: '',
    onBlur: () => { },
  }
}

export default Input;
